import React from "react";
import {
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import PrivateRoute from "./components/auth/PrivateRoute";
import Login from "./components/auth/Login";
import UpdatePassword from "./components/updatePassword/UpdatePassword";
import ForgotPassword from "./components/forgotPassword/ForgotPassword";
import VerifyOtp from "./components/forgotPassword/VerifyOtp";
import Layout from "./components/Layout/Layout";
import Main from "./components/Layout/Main";
// import Unauthorized from "./components/Unauthorized/Unauthorized";

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/admin"
          element={
            <Layout
              children={
                <PrivateRoute
                  element={<Main />}
                  allowedRoles={["Admin"]}
                />
              }
            />
          }
        />
        <Route
          path="/user"
          element={
            <Layout
              children={
                <PrivateRoute element={<Main />} allowedRoles={["User"]} />
              }
            />
          }
        />
        <Route path="/updatepassword" element={<UpdatePassword />} />
        <Route path="/forgot" element={<ForgotPassword />} />
        {/* <Route path="/forgot-password" element={<ForgotPassword />} /> */}
        <Route path="/verify-otp" element={<VerifyOtp />} />
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
